export function match(value) {
  return /^\w{2}$/.test(value)
}
